import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { loadStripe } from '@stripe/stripe-js';
import './CheckoutForm.css'
import { useCreatePaymentIntentQuery } from '../../features/api/apiSlice';
const stripePromise = loadStripe('pk_test_51KUC8RGmKC29pGIF1hjkYMCuZjmtYu6Qplo6QEgTBqnUOCgTAKul6A9Y8lT267VQBf07tjIW7es8FFl12JJn3B9C00XUR2ORmn')
const Payment = ({ deliveryInfo }) => {

    const { cartData } = deliveryInfo;

    let total = cartData?.reduce((total, prd) => total + (parseInt(prd.price) * prd.orderQuantity), 0)

    const { data: paymentSecret } = useCreatePaymentIntentQuery(total);
    const [clientSecret, setClientSecret] = useState("");

    useEffect(() => {
        setClientSecret(paymentSecret?.clientSecret);
    }, [paymentSecret?.clientSecret])

    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };
    return (
        <div className='payment-block'>
            {/* <Elements stripe={stripePromise}>
                <CheckoutForm deliveryInfo={deliveryInfo} />
            </Elements> */}
            {clientSecret && total && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm clientSecret={clientSecret} deliveryInfo={deliveryInfo} total={total} />
                </Elements>
            )}
        </div>
    );
}

export default Payment;
